export const GET_CHALLENGES = 'GET_CHALLENGES';
export const GET_CHALLENGES_SUCCESS = 'GET_CHALLENGES_SUCCESS';
export const GET_CHALLENGES_ERROR = 'GET_CHALLENGES_ERROR';
export const ACCEPT_CHALLENGE = 'ACCEPT_CHALLENGE';
export const ACCEPT_CHALLENGE_SUCCESS = 'ACCEPT_CHALLENGE_SUCCESS';
export const ACCEPT_CHALLENGE_ERROR = 'ACCEPT_CHALLENGE_ERROR';
